
export default {
  name: 'EventCard',

  props: {
    label: { type: String, default: '' },
    href: { type: String, default: '' },
    picWideUrl: { type: String, default: '' },
    picUrl: { type: String, default: '' },
    aspectWide: { type: Boolean, default: false },
  },
}
